import React from "react";
import { Table, Button, Alert } from "reactstrap";

const PincodeRanges = ({ ranges, warehousePincode, onRemoveRange }) => {
  // Group ranges by state
  const groupedRanges =
    ranges?.reduce((acc, range) => {
      if (!acc[range.state]) {
        acc[range.state] = {
          ranges: [],
          price: range.price,
        };
      }
      acc[range.state].ranges.push(range);
      return acc;
    }, {}) || {};

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3"></div>
      <div className="table-responsive">
        <Table className="table-centered table-nowrap mb-0">
          <thead>
            <tr>
              <th>State</th>
              <th>Shipping Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedRanges).length > 0 ? (
              Object.entries(groupedRanges).map(([state, data]) => (
                <tr key={state}>
                  <td>{state}</td>
                  <td>₹{data.price}</td>
                  <td>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        onRemoveRange(data.ranges[0]._id);
                      }}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No shipping rates configured. Add state-wise rates to begin.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {Object.entries(groupedRanges).length > 0 && (
        <div className="mt-3 text-muted small">
          <p className="mb-0">
            * Shipping rates are applied uniformly across all pincodes within
            each state
          </p>
        </div>
      )}
    </div>
  );
};

export default PincodeRanges;
